import { FormattedMessage } from "react-intl";
import Loader from "../../../../components/Common/Loader/Loader";
import UnlockIcon from "../../../../components/Common/SvgIcons/SocialIcons/UnlockIcon";
import EditIcon from "../../../../components/Common/SvgIcons/TableIcons/EditIcon";
import ToggleButton from "../../../../components/Common/ToggleButton/ToggleButton";
import Tooltip from "../../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../../tableColumnTypes";
import { admin } from "../admin";

export const userManagement = {
  name: <FormattedMessage id="USERMANAGE_MAINHEADER" />,
  path: (tenantName) => `${admin.path(tenantName)}/userManagement`,
  addUserPath: (tenantName) =>
    `${admin.path(tenantName)}/userManagement/addUser`,
  editUserPath: (tenantName, userId) =>
    `${admin.path(tenantName)}/userManagement/editUser/${userId}`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: admin.name,
      path: admin.path(tenantName),
      onClick: () => navigate(admin.path(tenantName)),
    },
    {
      key: 2,
      label: userManagement.name,
      path: userManagement.path(tenantName),
      onClick: () => navigate(userManagement.path(tenantName)),
    },
  ],
  columns: (
    navigate,
    tenantName,
    userId,
    handleUnlockUserAccount,
    handleUserStatus,
    unlockUserAccountLoader,
    toggleUserStatusLoader
  ) => [
    {
      ID: 1,
      name: <FormattedMessage id="USERMANAGE_SEARCHNAME" />,
      fieldName: "FirstName",
      value: (row) => row.FirstName + " " + row.LastName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="USERMANAGE_SEARCHEMAIL" />,
      fieldName: "EmailId",
      value: (row) => <a href={"mailto:" + row.EmailId}>{row.EmailId}</a>,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="USERMANAGE_SEARCHACTION" />,
      fieldName: "",
      value: (row) => (
        <Tooltip
          content={<FormattedMessage id="USERMANAGE_BTNEDIT" />}
          direction={"bottom"}
        >
          <span
            onClick={() => {
              if (row?.checked) {
                navigate(userManagement.editUserPath(tenantName, row.ID));
              }
            }}
          >
            <EditIcon cursor={row?.checked ? "pointer" : "not-allowed"} />
          </span>
        </Tooltip>
      ),
      sort: false,
    },
    {
      ID: 4,
      name: <FormattedMessage id="USERMANAGE_SEARCHSTATUS" />,
      fieldName: "",
      value: (row) => {
        return (
          <ToggleButton
            enable={row?.checked}
            leftText=" "
            rightText=" "
            handleClick={(e) => handleUserStatus(e, row.ID)}
            disabled={row?.IsSuperAdmin === 1 || row.ID === userId}
            isActive={row?.IsSuperAdmin === 1 || row.ID === userId}
          />
        );
      },
      sort: false,
    },
    {
      ID: 5,
      name: <FormattedMessage id="P_Unlock" />,
      fieldName: "",
      value: (row) => {
        return unlockUserAccountLoader === row?.ID ? (
          <Loader height={25} width={25} />
        ) : (
          <Tooltip
            content={<FormattedMessage id="P_Unlock" />}
            direction={"left"}
            show={row.IsLocked}
          >
            <span
              onClick={() => row.IsLocked && handleUnlockUserAccount(row.ID)}
            >
              <UnlockIcon fill={!row.IsLocked ? "#ADADAD" : undefined} />
            </span>
          </Tooltip>
        );
      },
      sort: false,
    },
  ],
};
